import { Box, HStack, Text } from '@rbilabs/universal-components';

import { AccordionActivatorButton } from 'components/accordion/styled';
import { getDesignToken, spacing } from 'styles/constants';
export const SignupAccordionItem = Box;

export const SignupAccordionActivatorButton = AccordionActivatorButton.withConfig({
  padding: 0,
});

export const SignupAccordionListItemContainer = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginBottom: spacing.$6,
});

export const SignupAccordionTitle = Text.withConfig({
  variant: 'copyTwo',
  color: getDesignToken('text-default'),
  alignSelf: 'flex-start',
  margin: 0,
  marginTop: '$1',
});

export const ContentContainer = Box;
